<template>
  <Portal to="modals">
    <!-- <transition name="fade"> -->
    <div class="gp_modal" :class="classs" @mousedown.self="handleCancel" @keyup.esc="handleCancel" ref="main" v-bind="scopeAttrs">
      <div class="gp_modal-backdrop" @mousedown.prevent="overlayClick" v-if="!noBackdrop"></div>
      <div class="gp_modal-container" :class="[cClass, padding]" @mousedown.left.self="$emit('container')">
        <div class="gp_modal-close" :class="closeClass" v-if="!hideExit" @click.prevent="handleCancel">
          <i class="icon icon-cancel" :class="iClass"></i>
        </div>
        <template v-if="hasHeader">
          <header class="gp_modal-container_header" :class="hClass">
            <slot name="header"></slot>
          </header>
          <hr v-if="!breakLine" class="line bg-dark-high" />
        </template>
        <header class="gp_modal-container_actions" :class="aClass" v-if="hasActions">
          <slot name="actions"></slot>
        </header>
        <section class="gp_modal-container_body" :class="mClass" v-if="hasBody">
          <slot></slot>
        </section>
        <footer class="gp_modal-container_footer mt-auto" :class="fClass" v-if="hasFooter">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
    <!-- </transition> -->
  </Portal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    aClass: String,
    cClass: String,
    hClass: {
      type: String,
      default: "p-4 pb-2"
    },
    iClass: {
      type: String,
      default: ""
    },
    closeClass: {
      type: String,
      default: "p-1"
    },
    mClass: {
      type: String,
      default: "p-4 pt-3"
    },
    fClass: {
      type: String,
      default: "p-4 pt-0"
    },
    padding: {
      type: String
    },
    noBackdrop: {
      type: Boolean,
      default: false
    },
    hideExit: {
      type: Boolean,
      default: true
    },
    breakLine: {
      type: Boolean,
      default: false
    },
    preventBackdrop: {
      type: Boolean,
      default: false
    },
    classs: String
  },
  computed: {
    hasHeader() {
      return !!this.$slots["header"] || !!this.$scopedSlots["header"];
    },
    hasActions() {
      return !!this.$slots["actions"] || !!this.$scopedSlots["actions"];
    },
    hasBody() {
      return !!this.$slots["default"] || !!this.$scopedSlots["default"];
    },
    hasFooter() {
      return !!this.$slots["footer"] || !!this.$scopedSlots["footer"];
    },
    scopeAttrs() {
      // Get the scope attribute name (undefined if none)
      const scopeAttr = this.$parent.$options._scopeId;
      return scopeAttr ? { [scopeAttr]: "" } : {};
    }
  },
  mounted() {
    const isInViewport = this.isInViewport();
    this.$store.commit("account/IS_MODAL_VIEWING", isInViewport);
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.$store.commit("account/IS_MODAL_VIEWING", false);
    },
    overlayClick() {
      if (this.preventBackdrop) {
        return;
      }
      this.$store.commit("account/IS_MODAL_VIEWING", false);
      this.handleCancel();
    },
    isInViewport() {
      const rect = this.$el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }
};
</script>

<style lang="scss">
$baseIndex: $modalIndex;
.gp_modal {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include flex-center;

  &-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &-container {
    position: relative;
    background: $bg;
    min-width: 424px;
    @media screen and (max-width: 576px) {
      min-width: unset;
    }
    max-height: 80vh;
    // height: 600px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;

    &_header {
      position: relative;
      // align-items: center;
      // display: flex;
    }

    &_actions {
      position: relative;
    }

    &_body {
      max-height: 80vh;
      overflow: overlay;
      @-moz-document url-prefix() {
        overflow: auto;
      }
    }
  }

  &-close {
    z-index: 1;
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    @include flex-center;
    // padding: 15px;
    // @include trans-all;
    color: $textLightModeLow;
    margin-left: auto;

    font-size: 18px;
    cursor: pointer;
    border-radius: $radius;
    // background: $light3;
    &:hover {
      color: $textLightModeHigh;
      background: $textDarkModeHigh;
    }
  }

  .line {
    background-color: $bg;
    height: 1px;
  }
}

.preview-template {
  padding: 0 !important;
  width: 100%;
  height: 100vh;
  border-radius: inherit;
  .index-0 {
    z-index: 0;
  }
  .gp_modal-container {
    &_body {
      max-height: unset;
      overflow: unset;
    }
  }
}
.height-unlimit {
  max-height: unset;
  overflow: unset;
}

.btn-select-template {
  padding: 15px 20px;
}

.w93p {
  width: 93%;
  position: relative;
}

.bg-white {
  background: white;
}

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
.app-details-close {
  top: 24px;
  right: 24px;
}

.w-200 {
  width: 600px;
}
.header-footer-not-avaible-body {
  padding: 20px 20px 16px 20px;
}
.header-footer-not-avaible-header {
  padding: 17px 20px;
}
</style>
